import { ConditionalPartial } from '../../../../utils';

import { CreateDispositionProcessConfigRequestDto } from './create-disposition-process-config.request.dto';

/**
 * DTO for updating disposition process configuration
 * All fields are optional for partial updates
 */
export class UpdateDispositionProcessConfigRequestDto extends ConditionalPartial(
    CreateDispositionProcessConfigRequestDto,
) {}
